<template>
  <div class="card-block">
    <h3 class="card-title">
      {{ $t("monthlyUsageHistory.labels.monthlyUsageHistory") }}
    </h3>
    <div class="row" v-if="isLoading">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <div class="p-t-15">
          <div class="row">
            <div class="col-xs-2 col-md-3">
              <div class="form-group">
                <select class="form-control" v-model="currentMonth" v-on:change="onChange()">
                  <option v-for="(month, index) in monthList" v-bind:value="month">{{month}}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-2 col-md-3" v-if="showReportDownload">
              <router-link v-bind:to="urlUsageReport()" class="btn btn-primary" target="_blank">{{ $t("monthlyUsageHistory.action.report") }}</router-link>
            </div>
          </div>
        </div>
        <div class="row" v-if="haveUsageItems">
          <div class="col-md-4 col-xs-12" v-for="(item, index) in usages.items">
            <div class="bg-blue-grey-100 p-35 clearfix m-b-30">
              <div class="pull-xs-left white m-t-20">
                <!-- Check from Data name -->
                <!-- Data tranfer -->
                <i class="icon icon-circle icon-2x md-swap-vertical bg-primary" v-if="item.item_category == 'dataTransfer'"></i>
                <i class="icon icon-circle icon-2x md-view-list bg-primary" v-else-if="item.item_category == 'storage'"></i>
                <i class="icon icon-circle icon-2x md-case-play bg-primary" v-else-if="item.item_category === 'VODUsage'"></i>
                <i class="icon icon-circle icon-2x md-swap-vertical bg-primary" v-else-if="item.item_category === 'InterBandwidth'"></i>
                <i class="icon icon-circle icon-2x md-tv-list bg-red-600 white" v-else-if="item.item_category === 'LiveTranscodeVM'"></i>
                <i class="icon icon-circle icon-2x md-truck bg-primary" v-else-if="item.item_category === 'Shipping'"></i>
                <i class="icon icon-circle icon-2x md-loupe bg-primary" v-else></i>
              </div>
              <div class="counter counter-md counter text-xs-right pull-xs-right">
                <div class="counter-number-group">
                  <span class="counter-number font-size-18" v-if="item.is_addon">{{item.description}}</span>
                  <span class="counter-number" v-else>{{ item.human_data_usage}}</span>
                </div>
                <div class="counter-label text-capitalize font-size-16" v-if="!item.is_addon">{{item.description}}</div>
                <div class="counter-label text-capitalize font-size-16" v-else>{{item.billing_description}}</div>
                <div class="counter-label text-capitalize font-size-16 grey-900" v-if="showCost"> {{item.human_cost}} {{ $t("billing.currencies.thb") }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary alert-dismissible" v-else>
          {{ $t("monthlyUsageHistory.labels.noUsageHistory") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.fetchUsages(this.currentMonth);
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    baseURL: function() {
      return process.env.BASE_URL;
    },
    monthList: function() {
      const list = [];

      const now = moment().startOf('months');
      const start = moment(this.team.created_at).startOf('months');
      const months = (now.diff(start, 'months'));
      list.push(now.format('MMMM YYYY'));

      for (let i = 0; i < months; i += 1) {
        list.push(now.subtract(1, 'months').format('MMMM YYYY'));
      }

      return list;
    },
    showReportDownload: function() {
      if (this.isLoading) {
        return false;
      }

      if (this.usages && this.usages.items <= 0) {
        return false;
      }

      const now = moment().startOf('months');
      const start = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).startOf('months');
      const months = (now.diff(start, 'months'));

      if (months > 0) {
        return true;
      }

      return false;
    },
    downLoadUrl: function() {
      if (this.team && this.currentUser) {
        if (this.$route.params.subnamespace) {
          const parentUrl = this.$route.params.namespace;
          const namespace = this.$route.params.subnamespace;

          let role;

          if (this.currentUser.team.is_superadmin) {
            role = 'admin';
          } else if (this.currentUser.team.is_reseller) {
            role = 'reseller';
          }

          return `/${parentUrl}/${role}/teams/${namespace}/usage-report`;
        } else {
          const namespace = this.$route.params.namespace;
          return `/${namespace}/usage-report`;
        }
      }
    },
    showCost: function () {
      if (this.currentUser) {
        return this.currentUser.role === 'manager';
      }
      return false;
    },
    haveUsageItems: function() {
      return (this.usages && this.usages.items && this.usages.items.length > 0);
    },
  },
  data: function () {
    return {
      isLoading: false,
      usages: null,
      currentMonth: moment().startOf('month').format('MMMM YYYY'),
    };
  },
  created: function() {
    this.isLoading = true;
    this.$emit('loadChanged', true);
  },
  mounted: function() {
    if (this.team) {
      this.fetchUsages(this.currentMonth);
    }
  },
  methods: {
    fetchUsages: function(month) {
      this.isLoading = true;

      const namespace = this.team.namespace;

      if (!month) {
        month = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      } else {
        month = moment(month, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      }

      axios.get(`/api/teams/${namespace}/usage?month=${month}`)
      .then((response) => {
        this.usages = response.data;
        this.isLoading = false;

        this.$emit('loadChanged', false);
      })
      .catch(() => {
        this.isLoading = false;

        this.$emit('loadChanged', false);
      });
    },
    onChange: function () {
      this.fetchUsages(this.currentMonth);
    },
    urlUsageReport: function () {
      let month = this.currentMonth;

      if (!month) {
        month = moment(this.currentMonth, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      } else {
        month = moment(month, ['MMMM YYYY', moment.ISO_8601]).format('YYYY-MM');
      }

      return `${this.downLoadUrl}?month=${month}`;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MonthlyUsageHistory.vue?697ceb8c